import { IconArrowNarrowRight } from '@rossum/ui/icons/tabler';
import {
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import { convertRateToPercentage } from '../../core/utils';
import { DifferenceChip } from './DifferenceChip';

export const DataCard = ({
  title,
  targetValue,
  currentValue,
  description,
}: {
  title: string;
  description: string;
  currentValue: number;
  targetValue: number | undefined;
}) => {
  const difference = targetValue ? targetValue - currentValue : null;

  // instead of showing differences like -0.000017 -> -0.0017%, we will ignore these small values and show 0%
  const isDifferenceTooSmall = difference
    ? Number(difference.toFixed(4)) === 0
    : false;

  const colorDataCy = isDifferenceTooSmall
    ? 'without-color'
    : typeof difference === 'number' && difference > 0
      ? 'success-colored'
      : 'warning-colored';

  return (
    <Card sx={{ width: 0.5 }}>
      <CardContent sx={{ py: 3, px: 4 }}>
        <Stack spacing={2} useFlexGap>
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            divider={
              <SvgIcon fontSize="medium" sx={{ color: 'text.disabled' }}>
                <IconArrowNarrowRight />
              </SvgIcon>
            }
          >
            <Typography
              color="text.secondary"
              data-cy="data-card-current-value"
            >
              {convertRateToPercentage(currentValue)}
            </Typography>
            {difference && targetValue ? (
              <Stack direction="row" spacing={1} useFlexGap>
                <Typography
                  color={
                    isDifferenceTooSmall
                      ? 'inherit'
                      : difference > 0
                        ? 'success'
                        : 'warning'
                  }
                  sx={{
                    minWidth: 60,
                    fontWeight: 500,
                    textAlign: 'center',
                  }}
                  data-cy={`data-card-${colorDataCy}-target-value`}
                >
                  {convertRateToPercentage(targetValue)}
                </Typography>
                <DifferenceChip
                  difference={isDifferenceTooSmall ? 0 : difference}
                  dataCy="data-card-difference"
                />
              </Stack>
            ) : null}
          </Stack>
          <Stack>
            <Typography variant="h5">{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
